import { Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { isFeuilleDeMatchFull } from '../../utils/feuilleMatch.js'
import { EMPTY_PLAYER } from '../../utils/helpers.js'


import { GAME_FACT_HANDBALL_PENALTY} from '../constants.js'
import TextCustom from '../generic/textCustom.js'
import { useGameFact } from '../useGameFact.js'
import { getTotalTimer, getVisualTimer } from '../../sports/rules.js'

const RecapHandballPenalty = ({state, match, onChangeText, onChangeTitle, inHistory}) => {
    const {team, timer, penaliter, penalitySucced, period} = state

    const [img, imgSucceed, imgFailed] = useGameFact({type : GAME_FACT_HANDBALL_PENALTY})

    const {homeHolders, homeSubstitutes, awayHolders, awaySubstitutes, homeTeam, awayTeam} = match

    let allPlayers = isFeuilleDeMatchFull(match) ? [...homeHolders, ...homeSubstitutes, ...awayHolders, ...awaySubstitutes] : [...match.homeTeam.players, ...match.awayTeam.players]

    let penaliterPlayer = allPlayers.find(p => p._id === penaliter) ?? EMPTY_PLAYER

    let teamSelected = [homeTeam, awayTeam].find(t => t._id === team)

    const actualPeriod = period ??  match.period

    // Gestion du text
    useEffect(() => {
        if(!state.text || state.edited){
            const monText = `Penalty  ${penalitySucced ? 'réussi' : 'raté'}${penaliterPlayer && penaliterPlayer.lastname && penaliterPlayer.lastname !== '...' ? ' par ' + penaliterPlayer.lastname : ''}!`;
            
            if(!inHistory)
                onChangeText && onChangeText(monText)
        }

        if(!state.title || state.edited){
            const monTitle = 'PENALTY'
            
            if(!inHistory){
                onChangeTitle && onChangeTitle(monTitle)
            }
                
        }
    }, [])

    return (
        <div style={{color : inHistory ? 'black' : 'white'}}>
            <img src={penalitySucced? imgSucceed : imgFailed} width={150}/>
            <Typography>Equipe : {teamSelected.name}</Typography>
            <Typography>
                {penaliterPlayer && penaliterPlayer.lastname && penaliterPlayer.lastname !== '...'
                    ? `Joueur : ${penaliterPlayer.lastname} ` 
                    : ''}
                ({penalitySucced ? 'Réussi' : 'Raté'})
            </Typography>
            {(timer !== 0 || period !== 0) && <Typography>Minute : {getVisualTimer(actualPeriod, timer, match.discipline)}</Typography>}
        
            {state.title && <TextCustom initialText={state.title} onChangeText={onChangeTitle} label={'Titre'}/>}
            {state.text && <TextCustom initialText={state.text} onChangeText={onChangeText} label={'Texte'}/>}
        </div>
    )
}

export default RecapHandballPenalty